var _path, _path2, _path3, _circle, _path4, _path5, _path6, _circle2, _path7, _path8, _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfrim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 265,
    height: 167,
    viewBox: "0 0 265 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M91.5686 10.149C91.5686 14.3265 98.2644 17.713 93.605 17.713C88.9456 17.713 85.1685 14.3265 85.1685 10.149C85.1685 5.97148 88.9456 2.58496 93.605 2.58496C98.2644 2.58496 91.5686 5.97148 91.5686 10.149Z",
    fill: "#FE964A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M157.73 6.5L158.862 9.9844H162.526L159.562 12.1379L160.694 15.6223L157.73 13.4688L154.766 15.6223L155.898 12.1379L152.934 9.9844H156.598L157.73 6.5Z",
    fill: "#FE964A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8782 80.1555C33.8782 80.1555 44.6263 74.8022 47.0645 77.6081C48.404 79.1496 49.4156 81.0166 48.2159 82.5335C47.2912 83.7028 45.956 83.8519 44.3916 83.5771C41.0788 82.9954 41.1291 78.3949 42.4589 75.5457C44.295 71.6119 54.0415 73.9338 54.0415 73.9338",
    stroke: "#0BA259",
    strokeWidth: 2.01707
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 228.717,
    cy: 74.7923,
    r: 5.88312,
    fill: "#FFEDEC"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5474 136.49L56.3844 129.271L62.2199 132.97L62.8851 126.913L68.2079 130.58L69.8656 124.032",
    stroke: "#2F78EE",
    strokeWidth: 1.68089
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M192.801 22.4252C192.801 22.4252 191.982 17.5644 194.331 16.5956C196.303 15.7817 198.014 19.3811 199.635 18.0761C201.277 16.7543 197.178 14.6603 198.513 13.0794C199.918 11.4155 204.429 13.0794 204.429 13.0794",
    stroke: "#2F78EE",
    strokeWidth: 2.01707
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4547 15.1409L54.0611 25.8971L48.6608 33.2613L32.4547 15.1409Z",
    fill: "#2F78EE"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 223.846,
    cy: 94.8124,
    r: 2.52134,
    fill: "#FFEDEC"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M199.616 128.002C202.387 128.281 205.08 124.065 204.769 127.156C204.458 130.247 201.96 132.526 199.189 132.247C196.418 131.968 194.424 129.237 194.735 126.146C195.046 123.055 196.845 127.723 199.616 128.002Z",
    fill: "#2F78EE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M208.61 39.4932L210.497 45.3005H216.603L211.663 48.8896L213.55 54.697L208.61 51.1078L203.67 54.697L205.557 48.8896L200.617 45.3005H206.723L208.61 39.4932Z",
    fill: "#0BA259"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 82.2998,
    y: 26.3232,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#27A376"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_535_3326)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 102.3,
    y: 46.3232,
    width: 60,
    height: 60,
    rx: 30,
    fill: "white",
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.184 69.1894C143.672 69.6775 143.672 70.469 143.184 70.9571L130.684 83.4571C130.196 83.9453 129.404 83.9453 128.916 83.4571L122.666 77.2071C122.178 76.719 122.178 75.9275 122.666 75.4394C123.154 74.9512 123.946 74.9512 124.434 75.4394L129.8 80.8055L141.416 69.1894C141.904 68.7012 142.696 68.7012 143.184 69.1894Z",
    fill: "#27A376"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_535_3326",
    x: 62.2998,
    y: 26.3232,
    width: 140,
    height: 140,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 20
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_535_3326"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_535_3326",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfrim);
export default __webpack_public_path__ + "static/media/confrim.5f8272e3e0602b6a9a871f7f8da5e866.svg";
export { ForwardRef as ReactComponent };